import { PasswordStrengthBarProgress } from "..";

export const containsOneLowercaseLetter = (value: string): boolean => {
    const regExp = /[a-z]/;

    return regExp.test(value);
};

export const containsOneUppercaseLetter = (value: string): boolean => {
    const regExp = /[A-Z]/;

    return regExp.test(value);
};

export const isEightCharactersLong = (value: string): boolean => {
    return value.length >= 8;
};

export const containsOneNumber = (value: string): boolean => {
    const regExp = /[0-9]/;

    return regExp.test(value);
};

export const getProgress = (value: string): PasswordStrengthBarProgress => {
    const _containsOneLowercaseLetter = containsOneLowercaseLetter(value);
    const _containsOneUppercaseLetter = containsOneUppercaseLetter(value);
    const _isEightCharactersLong = isEightCharactersLong(value);
    const _containsOneNumber = containsOneNumber(value);

    const isGreat =
        _isEightCharactersLong && _containsOneNumber && _containsOneUppercaseLetter && _containsOneLowercaseLetter;
    const isGood = _isEightCharactersLong && _containsOneUppercaseLetter && _containsOneLowercaseLetter;

    if (isGreat) {
        return PasswordStrengthBarProgress.GREAT;
    }

    if (isGood) {
        return PasswordStrengthBarProgress.GOOD;
    }

    return PasswordStrengthBarProgress.WEAK;
};
